module.exports = __webpack_public_path__ + "static/fonts/iconfont.a15f185a.woff2";